var DEFAULT_TIMEOUT = 5000;

function inlineTimeoutFrom(option) {
  return option || DEFAULT_TIMEOUT;
}

module.exports = inlineTimeoutFrom;



//////////////////
// WEBPACK FOOTER
// ./node_modules/clean-css/lib/options/inline-timeout.js
// module id = 725
// module chunks = 0 1